export default {
  hover: '#F3F3F4', // gray-200
};
